import { render } from "./PasReports.vue?vue&type=template&id=3ffdd317&scoped=true"
import script from "./PasReports.vue?vue&type=script&lang=js"
export * from "./PasReports.vue?vue&type=script&lang=js"

import "./PasReports.vue?vue&type=style&index=0&id=3ffdd317&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffdd317"]])

export default __exports__